var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{attrs:{"trigger":"none","interval":2500,"arrow":"always"}},_vm._l((_vm.slideInfo),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":item.pic_url}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69f90b68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/slideshow.vue
// module id = null
// module chunks = 